module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_LV-4726fcf7f6943be905dfb291d6fd5f0a.svg";